import React from "react";
import "../styles/vp-supplier-type.css";
import icon from "../../../assets/vp-experience-offered-icon.png";

function VPExperienceOffered({ userInfo }) {
  return (
    <div className="vp-supplier-type mb-3">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center">
            <img width={22} height={22} src={icon} alt="icon" />
            <h5 className="m-0 ms-2 vp-supplier-type-title">
              Experience offered
            </h5>
          </div>
        </div>
        <div className="card-body">
          <p className="vp-supplier-type-sub-title">
            What's the main type of product you offer?
          </p>

          {userInfo?.supplier?.categories?.map((item, index) => {
            return (
              <div
                key={index}
                className={`d-flex flex-column align-items-center ps-3 pe-3  mb-3 gap-1 ob-supplier-radio-item`}
              >
                <div
                  className={`d-flex align-items-start ob-supplier-radio-item-wrapper`}
                >
                  <div className={"ob-supplier-radio-item-icon"}>
                    <img src={icon} alt="icon" width={25} height={25} />
                  </div>
                  <div className={"ob-supplier-radio-item-text-container"}>
                    <p className={"m-0 vp-supplier-type-item-text1"}>
                      {item?.category?.category_name}
                    </p>
                    <p
                      className={"m-0 vp-supplier-type-item-text2"}
                      dangerouslySetInnerHTML={{
                        __html: item?.category?.key_information,
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default VPExperienceOffered;
